{
    "Skjema.input.dato.placeholder": "dd.mm.yyyy"
}
